import { render, staticRenderFns } from "./NewCreateBusiness.vue?vue&type=template&id=fbbc16e4&"
import script from "./NewCreateBusiness.vue?vue&type=script&lang=ts&"
export * from "./NewCreateBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./NewCreateBusiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports